import Big from 'big.js';
import {
  useEffect,
  useState
} from 'react';

export const useContainerDimensions = (myRef: React.MutableRefObject<HTMLHeadElement | null>) => {

  const [
    dimensions,
    setDimensions
  ] = useState({
    width: Big(0), height: Big(0)
  });

  const [
    isThrottled,
    setIsThrottled
  ] = useState(false);

  // delay between calls
  const delay = 100;

  useEffect(() => {
    const handleResize = () => {
      if (!isThrottled) {
        const dimensions = getDimensions(myRef);
        setIsThrottled(() => true);
        setDimensions((prev) => {
          if (prev.height !== dimensions.height || prev.width !== dimensions.width) {
            return dimensions;
          }
          return prev;
        });

        // timeout blocks hook from running between delay
        setTimeout(() => {
          setIsThrottled(() => false);
        }, delay);
      }


    };

    if (myRef.current) {
      setDimensions(() => getDimensions(myRef));
    }

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [
    isThrottled,
    myRef
  ]);

  return dimensions;
};

const getDimensions = (myRef: React.MutableRefObject<HTMLHeadElement | null>) => ({
  width: Big(myRef.current?.clientWidth ?? 0),
  height: Big(myRef.current?.clientHeight ?? 0)
});
